import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalSustainabilityComponent } from './modal-sustainability.component';
import { SvgModule } from '../../svg/svg.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ModalSustainabilityComponent],
  imports: [CommonModule, SvgModule, MatDialogModule],
  entryComponents: [ModalSustainabilityComponent]
})
export class ModalSustainabilityModule {}
